import { useEffect, useRef, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import API from "../config/config";

// Assume this is your API base constant file import

const Notification = () => {
  const ref = useRef();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const [loading, setLoading] = useState(false);

  const fetchNotifications = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("adminToken");
      console.log("Token  ", token);
      const res = await axios.get(API.ADMIN.GET_NOTIFICATION, {
        headers: { Authorization: `Bearer ${token}` },
      });

      // Assuming API response like { notifications: [], unreadCount: number }
      setNotifications(res.data.notifications || []);
      setUnreadCount(res.data.unreadCount || 0);
    } catch (error) {
      console.error("Failed to fetch notifications", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchNotifications();

    const checkIfClickedOutside = (e) => {
      if (isMenuOpen && ref.current && !ref.current.contains(e.target)) {
        setIsMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", checkIfClickedOutside);
    return () => {
      document.removeEventListener("mousedown", checkIfClickedOutside);
    };
  }, [isMenuOpen]);

  const markAsRead = async (notifId) => {
    try {
      const token = localStorage.getItem("adminToken");
      await axios.put(
        `${API.ADMIN.MARK_NOTIFICATION_READ}/${notifId}`,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      fetchNotifications(); // Refresh list and count
    } catch (err) {
      console.error("Failed to mark as read", err);
    }
  };

  return (
    <div className="relative inline-block text-left" ref={ref}>
      <div className="mr-1 relative">
        <button
          onClick={() => {
            setIsMenuOpen((prev) => !prev);
            if (!isMenuOpen) fetchNotifications();
          }}
          className="inline-flex justify-center w-full rounded-full border border-gray-300 shadow-sm px-2 py-2 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            className="size-6"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M14.857 17.082a23.848 23.848 0 0 0 5.454-1.31A8.967 8.967 0 0 1 18 9.75V9A6 6 0 0 0 6 9v.75a8.967 8.967 0 0 1-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 0 1-5.714 0m5.714 0a3 3 0 1 1-5.714 0"
            />
          </svg>

          {unreadCount > 0 && (
            <span className="absolute top-0 right-0 bg-red-600 text-white text-xs px-1.5 py-0.5 rounded-full">
              {unreadCount}
            </span>
          )}
        </button>
      </div>

      {isMenuOpen && (
        <div className="absolute -right-27 mt-2.5 flex h-90 w-75 flex-col rounded-sm border border-stroke bg-white shadow-default sm:right-0 sm:w-80 p-2 z-50">
          <div className="px-4.5 py-3">
            <h5 className="text-sm font-medium text-gray-700">Notifications</h5>
            {loading && <p className="text-xs text-gray-500">Loading...</p>}
          </div>

          <ul className="flex h-auto flex-col overflow-y-auto max-h-80">
            {notifications.length === 0 && !loading && (
              <li className="text-sm text-gray-500 px-4.5 py-3">
                No notifications yet.
              </li>
            )}

            {notifications.map((notif, index) => (
              <li key={index}>
                {console.log("noti", notif)}
                <button
                  className="w-full text-left flex flex-col gap-2.5 border-t border-stroke px-4.5 py-3 hover:bg-gray-100"
                  onClick={() => markAsRead(notif._id)}
                >
                  <p className="text-sm">
                    <span
                      className={`font-semibold ${
                        !notif.read ? "text-black" : "text-gray-500"
                      }`}
                    >
                      {notif.title}
                    </span>{" "}
                    {notif.body}
                  </p>
                  <p className="text-xs text-gray-500">
                    {new Date(notif.createdAt).toLocaleDateString()}
                  </p>
                </button>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default Notification;
